'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _memoize = require('transmute/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _isFromVisitor = require('conversations-schema/pubnub-message/operators/isFromVisitor');

var _isFromAgent = require('conversations-schema/pubnub-message/operators/isFromAgent');

var _getCustomEmailCaptureDelay = require('../../selectors/widgetDataSelectors/getCustomEmailCaptureDelay');

var _shouldCaptureVisitorEmailAddress = require('../../selectors/widgetDataSelectors/shouldCaptureVisitorEmailAddress');

var _widgetIsInAwayMode = require('../../availability/selectors/widgetIsInAwayMode');

var _publishEmailCapturePromptMessage = require('../actions/publishEmailCapturePromptMessage');

var _publishEmailCapturePromptMessage2 = _interopRequireDefault(_publishEmailCapturePromptMessage);

var _asyncActionTypes = require('../../pubsub/constants/asyncActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_AGENT_JOIN_TIMEOUT_IN_MS = 6000;
var ONE_SECOND_IN_MS = 1000;

var AgentResponseTimeoutMiddleware = function AgentResponseTimeoutMiddleware(store) {
  return function (next) {
    var timeouts = {};

    var clearResponseTimeout = function clearResponseTimeout(threadId) {
      return clearTimeout(timeouts[threadId]);
    };

    var setResponseTimeout = (0, _memoize2.default)(function (threadId, channel, delay) {
      timeouts[threadId] = setTimeout(function () {
        store.dispatch((0, _publishEmailCapturePromptMessage2.default)({ channel: channel, threadId: threadId }));
      }, delay);
    });

    return function (action) {
      switch (action.type) {
        case _asyncActionTypes.PUBLISH_MESSAGE.SUCCEEDED:
          {
            var _action$payload = action.payload,
                channel = _action$payload.channel,
                publishedMessage = _action$payload.publishedMessage,
                threadId = _action$payload.threadId;


            var isInAwayMode = (0, _widgetIsInAwayMode.widgetIsInAwayMode)(store.getState());

            /**
             * Once the visitor publishes his/her first message,
             * start a timer for a custom delay, if specified, or a standard delay
             */
            if ((isInAwayMode || (0, _shouldCaptureVisitorEmailAddress.shouldCaptureVisitorEmailAddress)(store.getState())) && (0, _messageTypeComparators.isConversationalMessage)(publishedMessage) && (0, _isFromVisitor.isFromVisitor)(publishedMessage)) {
              var customDelay = (0, _getCustomEmailCaptureDelay.getCustomEmailCaptureDelay)(store.getState());
              var timeout = isInAwayMode ? ONE_SECOND_IN_MS : customDelay || DEFAULT_AGENT_JOIN_TIMEOUT_IN_MS;

              setResponseTimeout(threadId, channel, timeout);
            }
            break;
          }

        case ActionTypes.RECEIVED_INCOMING_MESSAGE:
          {
            var _action$payload2 = action.payload,
                message = _action$payload2.message,
                _threadId = _action$payload2.threadId;

            /**
             * When a non-automated, conversational message is received from an agent,
             * cancel the timer
             */

            if ((0, _messageTypeComparators.isConversationalMessage)(message) && !(0, _messageTypeComparators.isAutomatedChatMessage)(message) && (0, _isFromAgent.isFromAgent)(message)) {
              clearResponseTimeout(_threadId);
            }
            break;
          }

        default:
          break;
      }

      return next(action);
    };
  };
};
exports.default = AgentResponseTimeoutMiddleware;
module.exports = exports['default'];